// Build table of contents from post content headings + scroll highlighting
export default function buildOutline() {
    const content = document.querySelector('.gh-post-content');
    const nav = document.querySelector('.gh-post-toc-nav');
    if (!content || !nav) return;

    const headings = content.querySelectorAll('h1, h2, h3');
    if (headings.length === 0) return;

    const links = [];

    headings.forEach((heading, i) => {
        if (!heading.id) {
            heading.id = 'section-' + (i + 1);
        }

        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        nav.appendChild(link);
        links.push({ link, heading });
    });

    // Highlight active section on scroll
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.id;
                links.forEach(({ link }) => {
                    link.classList.toggle('gh-toc-active', link.getAttribute('href') === '#' + id);
                });
            }
        });
    }, {
        rootMargin: '0px 0px -70% 0px',
        threshold: 0
    });

    links.forEach(({ heading }) => observer.observe(heading));
}
